<template>
    <div class="cc-contact" v-html="contact.html" v-if="contact.display"></div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                contact: state => state.contact,
            }),
        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/contact";
</style>
